import { FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_ERROR } from '../constants/ActionTypes';

export default function isFetchingUser(state = false, action) {
    switch (action.type) {
        case FETCH_USER_REQUEST:
            return true;
        case FETCH_USER_SUCCESS:
        case FETCH_USER_ERROR:
            return false;
        default:
            return state;
    }
}
